import { useEffect, useState } from "react";
import api from "@/lib/api";
import { prettyDate } from "@/lib/format";
import { ClipboardList } from "lucide-react";

export default function CustomerTasksPanel({ customerId, hideWhenEmpty = false, activeOnly = false }) {
  const [tasks, setTasks] = useState([]);

  useEffect(() => {
    if (!customerId) { setTasks([]); return; }
    api.get(`/customer-tasks?customer_id=${customerId}`).then(r => setTasks(r.data)).catch(() => {});
  }, [customerId]);

  const shown = activeOnly ? tasks.filter(t => t.active !== false) : tasks;
  if (!customerId) return null;
  if (hideWhenEmpty && !shown.length) return null;
  return (
    <div className="bg-white border border-slate-200 rounded-md p-4 no-print" data-testid="customer-tasks-panel">
      <div className="flex items-center gap-2 mb-3">
        <ClipboardList size={15} className="text-slate-500" />
        <h3 className="text-sm font-semibold">Customer Tasks / Notes</h3>
        <span className="ml-auto text-xs text-slate-400" data-testid="customer-tasks-count">{shown.length}</span>
      </div>
      {!shown.length && <div className="text-xs text-slate-400" data-testid="customer-tasks-empty">No tasks for this customer.</div>}
      <div className="space-y-2">
        {shown.map(t => (
          <div key={t.id} data-testid={`task-item-${t.id}`} className="border border-slate-200 rounded p-2.5">
            <div className="flex items-center gap-2 flex-wrap">
              <span className={`text-[10px] font-semibold uppercase tracking-wider px-1.5 py-0.5 rounded ${t.task_type_name ? "bg-blue-50 text-blue-800 border border-blue-200" : "bg-slate-100 text-slate-500 border border-slate-200"}`}>{t.task_type_name || "Not Mapped"}</span>
              <span className={`text-[10px] font-semibold uppercase tracking-wider px-1.5 py-0.5 rounded ${t.active !== false ? "bg-emerald-50 text-emerald-800 border border-emerald-200" : "bg-slate-100 text-slate-500 border border-slate-200"}`}>{t.active !== false ? "Active" : "Inactive"}</span>
              <span className="ml-auto text-[10px] text-slate-400 mono">{prettyDate((t.created_at || "").slice(0, 10))}</span>
            </div>
            <div className="text-sm text-slate-700 mt-1.5 whitespace-pre-line">{t.note}</div>
          </div>
        ))}
      </div>
    </div>
  );
}
